import React from 'react';
import styled from 'styled-components';
import CVSection from '../components/sections/CVSection';

const CVPage = () => {
  return (
    <CVPageContainer>
      <CVSection />
    </CVPageContainer>
  );
};

const CVPageContainer = styled.div`
  padding-top: 2rem;
`;

export default CVPage;